import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiosk');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

type KioskMode = 'main' | 'drink' | 'door' | 'parking' | 'room' | 'staff';

@Component({
    selector: 'wiz-page-kiosk',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.kiosk/view.scss */
:host {
  display: block;
}`],
})
export class PageKioskComponent implements OnInit, OnDestroy {
    public mode: KioskMode = 'main';

    private routerSub: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init(null as any);
        this.syncMode();

        this.routerSub = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) this.syncMode();
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
    }

    private syncMode() {
        const rawRouteMode = this.routeModeText();
        const routeMode = this.normalizeMode(rawRouteMode);
        const params = new URLSearchParams(window.location.search);
        const queryMode = this.normalizeMode(params.get('mode'));

        if (rawRouteMode && !routeMode) {
            this.navigateMode('main');
            return;
        }

        if (!rawRouteMode && queryMode) {
            this.navigateMode(queryMode);
            return;
        }

        if (this.isKioskRoot()) {
            this.navigateMode('main');
            return;
        }

        this.mode = routeMode || 'main';
    }

    private navigateMode(mode: KioskMode) {
        this.service.href(`/kiosk/${mode}${this.queryWithoutMode()}`);
    }

    private routeModeText() {
        const mode = (window as any).WizRoute?.segment?.mode;
        if (mode === null || mode === undefined) return '';
        return `${mode}`.trim();
    }

    private normalizeMode(mode: string | null): KioskMode | null {
        if (mode === 'main' || mode === 'drink' || mode === 'door' || mode === 'parking' || mode === 'room' || mode === 'staff') return mode;
        return null;
    }

    private queryWithoutMode() {
        const params = new URLSearchParams(window.location.search);
        params.delete('mode');
        const query = params.toString();
        return query ? `?${query}` : '';
    }

    private isKioskRoot() {
        return window.location.pathname.replace(/\/$/, '') === '/kiosk';
    }
}

export default PageKioskComponent;